import React, { useEffect, useState, Fragment } from 'react';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import _ from 'lodash';

import '../../../BotReport/index.css';
import '../../../../../Settings/Users/styles.scss';
import { getCompanyListUsers } from '../../../../../../store/actions/reports';

/**
 * Component for showing the list of users in this org
 *
 * @param {*} props
 * @returns
 */
const OrgListUsers = (props) => {
  const { getCompanyListUsers, match, user, orgListUsers, searchTerm } = props;
  const { orgId } = match.params;
  const token = user.dashboard_token;

  const [listUsers, setListUsers] = useState([]);

  /**
   * Called for fetch new data for this component
   */
  useEffect(() => {
    getCompanyListUsers(orgId, token);
  }, []);

  /**
   * Called for render the component and change values on UI
   */
  useEffect(() => {
    setListUsers(orgListUsers);
  }, [orgListUsers]);

  /**
   * Called when the searchTerm change, for update the filtered list of elements
   */
  useEffect(() => {
    updateCurrentList();
  }, [searchTerm]);

  /**
   * Update the current list used for displaying the cards
   */
  const updateCurrentList = () => {
    if (searchTerm === '') {
      setListUsers(orgListUsers);
    } else {
      formatCustomListUsers();
    }
  };

  /**
   * Format the current list for a custom filtered by the search term
   */
  const formatCustomListUsers = () => {
    const filterList = _.filter(listUsers, (user) => {
      const hasName =
        user.name.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1;
      const hasEmail =
        user.email.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1;

      if (hasName || hasEmail) {
        return user;
      }
    });

    setListUsers(filterList);
  };

  const renderUsersList = () => {
    return _.map(listUsers, (user, index) => {
      return (
        <div
          key={index}
          className="d-flex align-items-center pt-2 pb-2 pl-2 pr-1 users-content-line user-list-line"
        >
          <img
            src={
              user.profilePhoto ||
              require('../../../../../../assets/images/user_no_profile_photo.svg')
            }
            alt=""
          />
          <div className="users-content-line-data row">
            <div className="col-md-12 users-content-line-data-name">
              {user.name}
            </div>
            <div className="col-md-6 users-content-line-data-other">
              {user.email}
            </div>
            <div className="col-md-6 users-content-line-data-other">
              CPF: {user.cpf || '-'}
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="users-content container-user-list-lines">
      {renderUsersList()}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.users.signedUser,
    orgListUsers: state.reports.orgListUsers,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ getCompanyListUsers }, dispatch);
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OrgListUsers)
);
